/**
 * Enum correspondente aos tipo de procedencia de acordo.
 */
export enum TipoProcedenciaAcordoEnum {

    JUDICIAL        = 1,
    ADMINISTRATIVO  = 2
}
